var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 157,
    viewBox: "0 0 158 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.792 71.9585H33.2083C25.9826 71.9585 20.125 77.8161 20.125 85.0418V130.833C20.125 138.059 25.9826 143.917 33.2083 143.917H124.792C132.017 143.917 137.875 138.059 137.875 130.833V85.0418C137.875 77.8161 132.017 71.9585 124.792 71.9585Z",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2916 71.9585V45.7918C46.2916 37.117 49.7377 28.7975 55.8717 22.6635C62.0057 16.5295 70.3252 13.0835 79 13.0835C87.6747 13.0835 95.9942 16.5295 102.128 22.6635C108.262 28.7975 111.708 37.117 111.708 45.7918V71.9585",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.913f64ebee08e21e4bb046578440ec0c.svg";
export { ForwardRef as ReactComponent };